import api from "."
import { TLocationCoordinate } from "../types";

const searchPlacesAlexgrill = async (request: string, restaurantCoordinate: TLocationCoordinate) => {
  const response = await api.getGeocoding(request, restaurantCoordinate)
  return response
}

const searchPlaces = searchPlacesAlexgrill;

export default searchPlaces;
